import { render } from "./volumebased-price-form.vue?vue&type=template&id=1721c5ce"
import script from "./volumebased-price-form.vue?vue&type=script&lang=js"
export * from "./volumebased-price-form.vue?vue&type=script&lang=js"

import "./volumebased-price-form.vue?vue&type=style&index=0&id=1721c5ce&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__